import { field, formThemes } from '../types';
import { FormControl, Select, MenuItem, FormHelperText, InputLabel } from '@mui/material';
import { getErrorText } from '..';
import { CustomSelect, CustomTextField } from 'theme/elements/Inputs';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppSelector } from 'hooks/redux.hooks';

type props = {
	valid: boolean;
	cField: field;
	initialValidation: any;
	handleChange: any;
	formTheme?: formThemes;
};

export default function SelectBox(props: props) {
	const t = useAppSelector(selectTranslations);
	const { valid, cField, handleChange, initialValidation, formTheme } = props;
	const { name, value, label, placeholder, options, required } = cField.props;
	const variant = formTheme === formThemes.hiddenInputs ? 'outlined' : 'filled';
	return (
		<FormControl error={!valid} fullWidth sx={cField.styleObj}>
			<CustomSelect key={name}>
				{/*<InputLabel id="country-label">
					{label}
					{required ? ' *' : ''}
        </InputLabel>*/}
				<Select
					{...cField.props}
					error={!valid}
					//label={label}
					name={name}
					value={value || ''}
					onChange={handleChange}
					placeholder={placeholder}
					variant="outlined"
				>
					{options?.map((option, idx) => {
						const val = cField.valueProperty ? option[cField.valueProperty] : option.value;
						const lab = cField.labelProperty ? option[cField.labelProperty] : t(option.label);
						return (
							<MenuItem key={`select-option-${idx}`} value={val}>
								{lab}
							</MenuItem>
						);
					})}
				</Select>
			</CustomSelect>
			<FormHelperText error={!valid}>{t(getErrorText(initialValidation, name))}</FormHelperText>
		</FormControl>
	);
}
